module.exports = __webpack_public_path__ + "img/FABRIC.caaf8125.jpeg";